/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {
//   // Add custom code below this line

//   // Función para cambiar el texto del enlace
//   function updateSubscriptionLinks() {
//     document.querySelectorAll('.subscriptions_link.h5').forEach(function(link) {
//       const subscriptionId = link.href.split('/').pop(); // Extrae el ID de la suscripción desde el enlace
//       link.textContent = `Gestionar mi suscripción: ${subscriptionId}`;
//     });
//   }

//   // Crear un MutationObserver para detectar cuando el elemento aparece en el DOM
//   const observer = new MutationObserver(function(mutations) {
//     mutations.forEach(function(mutation) {
//       if (document.querySelectorAll('.subscriptions_link.h5').length > 0) {
//         updateSubscriptionLinks(); // Ejecuta la función cuando los elementos están disponibles
//         observer.disconnect(); // Deja de observar una vez que se ha encontrado el elemento
//       }
//     });
//   });

//   // Configuración del observer para monitorear cambios en el cuerpo del documento
//   observer.observe(document.body, {
//     childList: true,  // Observar cuando se agreguen o eliminen nodos hijos
//     subtree: true     // Observar dentro de todos los nodos hijos
//   });


//   // ^^ Keep your scripts inside this IIFE function call to 
//   // avoid leaking your variables into the global scope.
// })();

document.addEventListener('DOMContentLoaded', function() {
  const labels = document.querySelectorAll('.product__subs__group');

  labels.forEach(label => {
      const input = label.querySelector('input[type="radio"][name="selling-plan-group"]');

      input.addEventListener('click', () => {
          labels.forEach(l => l.classList.remove('active')); // Remove 'active' class from all labels
          label.classList.add('active'); // Add 'active' class to the clicked label
      });
  });
});